import PropTypes from 'prop-types';
import { getConfig } from '../config.js';
import { getClientSlug } from '../helpers/clientSlug';
import { withClientIpHeader } from '../helpers/requestHeaders';

export default async function apiServicewt(quary, _navigate, options = {}) {
	const webLink = getConfig().REACT_APP_WEB_LINK;
	const slug = getClientSlug();
	const payload = slug ? { ...quary, slug } : quary;
	const { headers: customHeaders = {}, ...fetchOptions } = options;
	let storedUserAuth = {};
	let storedGuestAuth = {};

	try {
		storedUserAuth = JSON.parse(localStorage.getItem('user-auth')) || {};
	} catch (error) {
		storedUserAuth = {};
	}

	try {
		storedGuestAuth = JSON.parse(localStorage.getItem('guest-user-auth')) || {};
	} catch (error) {
		storedGuestAuth = {};
	}

	const sdkAuthorization =
		customHeaders['sdk-authorization'] ||
		payload?.old_token ||
		storedUserAuth?.session_key ||
		storedGuestAuth?.session_key ||
		'.';

	const headers = await withClientIpHeader({
		'Content-Type': 'application/json',
		Accept: 'application/json',
		'sdk-authorization': sdkAuthorization,
		...customHeaders,
	});

	const result = await fetch(webLink, {
		method: 'post',
		headers,
		body: JSON.stringify(payload),
		...fetchOptions,
	});
	const responce = await result.json();
	if (responce.type === 'error') {
	}
	return responce;
}

apiServicewt.propTypes = {
	quary: PropTypes.isRequired,
};
